module.exports = __webpack_public_path__ + "img/20.d6f38fc2.jpg";